export default "__VITE_ASSET__c9a5c705__"